import { IAudioItem } from 'types/audio'
import { IMediaItem, MediaStatus } from 'types/media'
import { isVisualMediaItem } from 'utils/media'
import { isPlayheadOverItem } from 'utils/timeline'
import { isBlobUrl } from 'utils'
import { videoTypes } from 'consts'

export const getTimeLineItemStartTime = (item: IMediaItem | IAudioItem) => {
  if (isVisualMediaItem(item.type)) {
    return (item as IMediaItem).startTime
  }
  return (item as IAudioItem).projectStart
}

export const isTimelineItemOverlappedWithPlayhead = (
  timelineItem: IMediaItem | IAudioItem,
  playheadTime: number
) => {
  const itemStartTime = getTimeLineItemStartTime(timelineItem)

  return isPlayheadOverItem({
    itemStartTime,
    itemDuration: timelineItem.duration,
    playheadTime
  })
}

export const findVideoItemOverlappingWithPlayhead = (
  visualMediaItems: IMediaItem[],
  playheadTime: number
): IMediaItem | undefined => {
  // filt video items with ready status
  const videoItemsWithReadyStatus = visualMediaItems.filter(
    item =>
      videoTypes.includes(item.type) && item.meta.status === MediaStatus.OK
  )

  // filter out blob URLs
  const videoItems = videoItemsWithReadyStatus.filter(
    item => !isBlobUrl(item.meta.path)
  )

  // find video items overlapping with playhead
  const overlappingItem = videoItems.find(item =>
    isTimelineItemOverlappedWithPlayhead(item, playheadTime)
  )

  return overlappingItem
}
